module.exports = __webpack_public_path__ + "img/logo.e9535365.png";